import { useStripe, useElements } from "@stripe/react-stripe-js";
import StripeService from "../services/stripe-service";

/**
 * Custom hook for Stripe operations
 * Provides access to Stripe elements and service methods
 */
export const useStripeService = () => {
  const stripe = useStripe();
  const elements = useElements();

  const handlePaymentSubmission = async (params: {
    event: React.FormEvent;
    paymentIntentId: string;
    clientSecret: string;
    customer: any;
    price: number;
    termsAccepted: boolean;
    skuPriceMap: any;
    selectedProduct: any;
    selectedPaymentMethodType?: string;
    currency?: string;
  }) => {
    return StripeService.handlePaymentSubmission({
      ...params,
      stripe,
      elements,
    });
  };

  const updatePaymentIntent = StripeService.updatePaymentIntent;

  return {
    stripe,
    elements,
    handlePaymentSubmission,
    updatePaymentIntent,
  };
};

export default useStripeService;